<!-- resources/js/Layout/Header.vue -->
<template>
  <header
    class="fixed md:static top-0 left-0 w-full z-50 bg-white/95 backdrop-blur-md border-b border-border"
  >
    <!-- hlavní lišta -->
    <div
      class="flex items-center h-14 md:h-16 max-w-screen-2xl pl-2 pr-4 md:px-8 lg:px-12 mx-auto"
    >
      <!-- logo vlevo – zvýšený z-index, aby nebyl překryt 
      <Link href="/" class="shrink-0 flex items-center relative z-[52]">
        <img :src="'/img/logo.png'" alt="Logo" class="h-10 md:h-12 w-auto" />
      </Link>-->

      <!-- kontakty (jen nepřihlášený) -->
      <div
        v-if="!isLoggedIn"
        class="hidden lg:flex flex-1 justify-center items-center gap-4 text-base text-muted-foreground"
      >
        <div class="flex items-center gap-2 bg-muted/70 px-4 py-2 rounded-full font-semibold">
          <PhoneIcon class="h-4 w-4" />
          <span>+420&nbsp;123&nbsp;456&nbsp;789</span>
        </div>
        <div class="flex items-center gap-2 bg-muted/70 px-4 py-2 rounded-full font-semibold">
          <MailIcon class="h-4 w-4" />
          <span>email@email.cz</span>
        </div>
      </div>

      <!-- navigace -->
      <nav class="hidden md:flex items-center gap-5 ml-auto">
        <Link href="/"          class="text-muted-foreground hover:text-foreground font-semibold text-lg">Úvod</Link>
        <Link href="/nabidka"   class="text-muted-foreground hover:text-foreground font-semibold text-lg">Nabídka</Link>
        <Link href="/vykup"     class="text-muted-foreground hover:text-foreground font-semibold text-lg">Výkup</Link>
        <Link href="/dovoz"     class="text-muted-foreground hover:text-foreground font-semibold text-lg">Dovoz&nbsp;na&nbsp;zakázku</Link>
        <Link href="/onas"      class="text-muted-foreground hover:text-foreground font-semibold text-lg">O&nbsp;nás</Link>
        <Link href="/kontakt"   class="text-muted-foreground hover:text-foreground font-semibold text-lg">Kontakt</Link>

        <!-- akce pro přihlášeného -->
        <template v-if="isLoggedIn">
          <Link href="/nabidka/create" class="text-green-600 hover:text-green-800 font-semibold text-lg">Přidat&nbsp;auto</Link>
          <button @click="logout"      class="text-red-600 hover:text-red-800 font-semibold text-lg">Odhlásit&nbsp;se</button>
        </template>
      </nav>

      <!-- hamburger -->
      <button
        @click="isMobileMenuOpen = !isMobileMenuOpen"
        class="md:hidden text-foreground focus:outline-none z-[51] ml-auto"
      >
        <svg
          v-if="!isMobileMenuOpen"
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- mobilní menu -->
    <transition name="fade">
      <div
        v-if="isMobileMenuOpen"
        class="mobile-menu-panel fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/95 backdrop-blur-md border-t border-border px-8 py-8 md:hidden text-center"
      >
        <nav class="flex flex-col gap-6 w-full">
          <Link @click="closeMobileMenu" href="/"          class="text-foreground font-semibold text-2xl py-2">Úvod</Link>
          <Link @click="closeMobileMenu" href="/nabidka"   class="text-foreground font-semibold text-2xl py-2">Nabídka&nbsp;vozidel</Link>
          <Link @click="closeMobileMenu" href="/vykup"     class="text-foreground font-semibold text-2xl py-2">Výkup&nbsp;vozidel</Link>
          <Link @click="closeMobileMenu" href="/dovoz"     class="text-foreground font-semibold text-2xl py-2">Dovoz&nbsp;na&nbsp;zakázku</Link>
          <Link @click="closeMobileMenu" href="/onas"      class="text-foreground font-semibold text-2xl py-2">O&nbsp;nás</Link>
          <Link @click="closeMobileMenu" href="/kontakt"   class="text-foreground font-semibold text-2xl py-2">Kontakt</Link>

          <template v-if="isLoggedIn">
            <Link    @click="closeMobileMenu" href="/nabidka/create" class="text-green-600 font-semibold text-2xl py-2">Přidat&nbsp;auto</Link>
            <button  @click="logout" class="text-red-600 font-semibold text-2xl py-2">Odhlásit&nbsp;se</button>
          </template>
        </nav>

        <!-- kontakty (jen nepřihlášený) -->
        <div v-if="!isLoggedIn" class="flex flex-col gap-4 text-base text-muted-foreground w-full mt-8 items-center">
          <div class="flex items-center gap-2 bg-muted/70 px-4 py-2 rounded-full font-semibold">
            <PhoneIcon class="h-4 w-4" />
            <span>+420&nbsp;123&nbsp;456&nbsp;789</span>
          </div>
          <div class="flex items-center gap-2 bg-muted/70 px-4 py-2 rounded-full font-semibold">
            <MailIcon class="h-4 w-4" />
            <span>email@email.cz</span>
          </div>
        </div>
      </div>
    </transition>
  </header>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Link, usePage, router } from '@inertiajs/inertia-vue3'
import { Phone as PhoneIcon, Mail as MailIcon } from 'lucide-vue-next'


/* ---- přihlášení ---- */
const page = usePage()
const isLoggedIn = computed(() => !!page.props.value.auth?.user)

/* ---- mobilní menu ---- */
const isMobileMenuOpen = ref(false)
function closeMobileMenu() {
  isMobileMenuOpen.value = false
}

/* ---- odhlášení ---- */
function logout() {
  closeMobileMenu()
  router.post('/logout')
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter-from,
.fade-leave-to   { opacity: 0; }

.mobile-menu-panel { min-height: 100dvh; }
</style>
